<template>
    <div v-if="config.display" :style="{'width': config.width || '100%'}" class="control e-control">
        <label-wrapper :label-settings="config"></label-wrapper>
        <div v-if="asField">
            <display-value :id="config.id" :value="value"></display-value>
        </div>
        <div v-else>
            <div v-if="!optionsReady" class="loading-message">
                Getting data. Please wait...
            </div>
            <div v-else>
                <div>
                    <ejs-dropdowntree
                        v-bind="localConfig"
                        v-model="value"
                        :fields="dropdownFields"
                        :treeSettings="{ expandOn: 'Click', loadOnDemand: true }"
                        :ref="refId"
                        :changeOnBlur="false"
                        @change="change"
                        :data-test-id="dataTestId"
                        :enabled="!config.disabled"
                        :showClearButton="showClearButton"
                        :itemTemplate="itemTemplate"
                    ></ejs-dropdowntree>
                </div>
                <div class="sub-content-area">
                    <div class="message-container" v-if="config.message">
                        <p class="input-info" v-html="ddStoreFilter(config.message)"></p>
                        <p v-if="missingOptions.length" class="missing-options-message"><strong>Note:</strong> One or more selected values does not match any available options.</p>
                    </div>
                    <div class="secondary-action-container" v-if="config.secondaryActions">
                        <ejs-splitbutton
                            :disabled="config.disabled"
                            :content="config.secondaryActions[0].text"
                            :items="config.secondaryActions.slice(1)"
                            v-on:click="runSecondaryAction($event)"
                            v-on:select="runSecondaryAction($event)"
                            class="secondary-action-button"
                        ></ejs-splitbutton>
                    </div>
                    <sam-tooltip
                        v-if="missingOptions.length"
                        ref="tooltip"
                        opensOn="Click"
                        content="<strong>Note:</strong> One or more selected values does not match any available options."
                        label="options missing"
                        label-classes=""
                        :id="config.id"
                    ></sam-tooltip>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { defineAsyncComponent } from "@common/defineAsyncComponent";
import SamTooltipComponent from "@common/control/samTooltip";
import { library } from "@common/library/library";
import { controlMixins } from "./controlMixins.js";

export const dropdownTreeComponent = {
    mixins: [controlMixins],
    computed: {
        localConfig() {
            let localConfig = library.cloneObj(this.syncfusionConfig);
            delete localConfig.allowMultiSelection; // cause issues, use showCheckBox instead
            return localConfig;
        },
        refId() {
            return this.config.ref || this.config.id;
        },
        showClearButton() {
            return typeof this.config.showClearButton !== 'undefined' ? this.config.showClearButton : true;
        },
        dropdownFields() {
            let fields = this.config.fields;
            let setField = (prop, dVal) => (typeof fields[prop] !== 'undefined' ? fields[prop] : (dVal || prop));
            return {
                dataSource: this.options,
                text: setField('text'),
                value: setField('value'),
                hasChildren: setField('hasChildren', 'hasChild'),
                parentValue: setField('parentValue', 'pId'),
                selectable: setField('selectable'),
                htmlAttributes: setField('htmlAttributes'),
            };
        },
        itemTemplate() {
            if (!this.config.itemTemplate) {
                return null;
            }
            let templateId = 'itemTemplate_' + this.config.name;

            let tmpCmp = vueApp.component(templateId, {
                template: '<div>' + this.config.itemTemplate + '</div>',
                data() {
                    return {
                        config: this.config,
                        data: {}
                    };
                }
            });
            let tmpFunc = function () {
                return {
                    template: tmpCmp
                };
            };
            Object.defineProperty(tmpFunc, "name", { value: templateId });
            return tmpFunc;
        }
    },
    methods: {
        change(event) {
            this.action.call(null, event, 'onchange');
        }
    },
    components: {
        'ejs-dropdowntree': defineAsyncComponent(() => import('@common/syncfusion/dropdownTree')),
        'ejs-splitbutton': defineAsyncComponent(() => import('@common/syncfusion/splitButton')),
        'sam-tooltip': SamTooltipComponent
    }
};

export default dropdownTreeComponent;
</script>
<style scoped>
.sub-content-area {
    display: flex;
}
.sub-content-area > div {
    margin: 0 10px;
    position: relative;
    top: -4px;
}
.sub-content-area > div + div {
    margin-left: 0;
}
.sub-content-area > div.message-container {
    flex-grow: 9;
}
.secondary-action-button {
    text-decoration: underline;
    color: #0B4A97;
    padding: 5px 8px;
    background: #eee;
    font-size: 14px;
    border-radius: 0 0 6px 6px;
    white-space: nowrap;
}
</style>
<style>
.e-treeview .e-list-item.e-hover > .e-text-content {
    background-color: #f5f5f5;
    border-color: #f5f5f5;
}

.e-treeview .e-list-item div.e-icons::before {
    content: "\e22f" !important;
}

.e-ddt .e-ddt-icon::before {
    content: "\e969" !important;
}
.e-list-item.e-prevent .e-fullrow {
    cursor: pointer !important;
}
.e-list-item[prevent-select='true'] > .e-text-content .e-checkbox-wrapper {
    display: none;
}
</style>
